import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Insta from '../components/insta';
import { Grid } from "@material-ui/core";

import elBleeding from '../images/elbleeding.gif';

import '../styles/index.scss';

const castInsta = [
  "https://www.instagram.com/p/B0q47eqH5rq/",
  "https://www.instagram.com/p/ByDOwwvBqEf/",
  "https://www.instagram.com/p/Bo-WhpOHy7t/",
  "https://www.instagram.com/p/BzHmg73nQHA/",
  "https://www.instagram.com/p/ByaejhGActi/",
  "https://www.instagram.com/p/ByQWOE9hLdX/",
  "https://www.instagram.com/p/BhiNC4ZhWIi/",
  "https://www.instagram.com/p/Bd3ImgOH-wr/",
  "https://www.instagram.com/p/B3Gk0U7AqZE/",
  "https://www.instagram.com/p/Bln_QqXABLg/",
  "https://www.instagram.com/p/ByY08aDnEAX/",
  "https://www.instagram.com/p/B735RLdA-7v/",
  "https://www.instagram.com/p/B53BcsPggwf/",
  "https://www.instagram.com/p/B7i--dhgD6u/",
  "https://www.instagram.com/p/B6Bpyduhk7l/",
  "https://www.instagram.com/p/B2URiCxHk36/",
  "https://www.instagram.com/p/B5ib1ZYB1DF/",
  "https://www.instagram.com/p/BWs42DagE6A/",
]

const description = `Home page of stranger things stuffs. ready to do another nerdy stuff related to stranger things? have fun... good luck`;
const keywords = [
  "stranger things stuffs",
  "stranger things",
  "nerdy stuffs",
  "nerd",
  "homepage",
  "ST",
  "Millie Bobby Brown",
  "Noah Schnapp",
  "Gaten Matarazzo",
  "Finn Wolfhard",
  "Caleb McLaughlin",
  "Sadie Sink",
  "Natalia Dyer",
  "Charlie Heaton",
  "David Harbour",
  "Winona Ryder"
]

const IndexPage = () => (
  <Layout navNumber={0}>
    <SEO title="Home" description={description} keywords={keywords.join(",")} />
    <h1>Hi Nerds</h1>
    <p>Welcome to your new nerdy ST Stuffs website.</p>
    <figure>
      <div style={{ maxWidth: `300px`, marginBottom: `0rem` }}>
        <img src={elBleeding} alt="El" />
      </div>
      <figcaption>
        <a style={{ color: "#000", fontSize: "0.8em" }} href="https://dribbble.com/shots/6751207--I-think-I-see-it">https://dribbble.com/shots/6751207--I-think-I-see-it</a>
      </figcaption>
    </figure>
    <br />
    <p>Go have some fun with the Stranger Things Stuffs.</p>
    <Link to="/stranger-things-quiz/">Go to Quiz page</Link>
    <br />
    <Link to="/stranger-things-face-similarity/">Go to Face Similarity page</Link>
    <br />
    <Link to="/stranger-things-avatar-generator/">Go to Avatar Generator page</Link>
    <br />
    <br />
    <br />
    <div>
      <iframe width="100%" height="400" src="https://www.youtube-nocookie.com/embed/5_Q5EV3MbdU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    {/* <div className="cast-social">
      <h2>Cast Social Media: </h2>
      <Grid container spacing={0}>
        {
          castInsta.map((c) => (
            <Grid key={c} item xs={12} sm={12} md={12} lg={12}><Insta url={c} /></Grid>
          ))
        }
      </Grid>
    </div> */}
    <div>
      <h2>References: </h2>
      <ul>
        <li><a href="https://www.netflix.com/nl-en/title/80057281">Stranger Things</a> show</li>
        <li>Some <a href="https://lottiefiles.com/">lottiefiles GIF</a> animations</li>
        <li>Font made from <a href="http://www.onlinewebfonts.com">oNline Web Fonts</a> is licensed by CC BY 3.0</li>
        <li><a href="https://dribbble.com">Dribbble</a></li>
        <li><a href="https://www.clipart.email/download/19446036.html">Eleven Using Her Power</a> Image</li>
      </ul>
    </div>
  </Layout>
)

export default IndexPage
